document.documentElement.classList.remove('no-js');

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});

window.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-email-discount-popup]');
  if (!popup) return;

  const success = popup.querySelector('[data-popup-success]');
  const DAY_MS = 24 * 60 * 60 * 1000;
  const legacyDismissed = localStorage.getItem('kv-email-popup-dismissed') === '1';
  const dismissedAtRaw = localStorage.getItem('kv-email-popup-dismissed-at');
  const dismissedAt = dismissedAtRaw ? Number(dismissedAtRaw) : 0;
  const subscribed = localStorage.getItem('kv-email-popup-subscribed') === '1';

  // Clear the old forever-dismissed flag from earlier theme versions.
  if (legacyDismissed) {
    localStorage.removeItem('kv-email-popup-dismissed');
  }

  const dismissed = Number.isFinite(dismissedAt) && dismissedAt > 0 && (Date.now() - dismissedAt) < DAY_MS;
  if (!dismissed && dismissedAtRaw) {
    localStorage.removeItem('kv-email-popup-dismissed-at');
  }

  const openPopup = () => {
    popup.hidden = false;
    document.body.classList.add('popup-open');
  };
  const closePopup = () => {
    popup.hidden = true;
    document.body.classList.remove('popup-open');
    if (!success) localStorage.setItem('kv-email-popup-dismissed-at', String(Date.now()));
  };

  popup.querySelectorAll('[data-popup-close]').forEach((btn) => btn.addEventListener('click', closePopup));

  if (success) {
    localStorage.setItem('kv-email-popup-subscribed', '1');
    localStorage.removeItem('kv-email-popup-dismissed');
    localStorage.removeItem('kv-email-popup-dismissed-at');
    openPopup();

    // Apply the unlocked Shopify discount to the visitor's browser session.
    // Shopify's /discount/CODE route persists the code so it appears at checkout.
    const code = popup.dataset.discountCodeValue;
    const redirectPath = popup.dataset.discountRedirect || '/';
    const appliedKey = code ? `kv-discount-applied-${code}` : '';
    if (code && !sessionStorage.getItem(appliedKey)) {
      sessionStorage.setItem(appliedKey, '1');
      const target = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;
      window.setTimeout(() => window.location.replace(target), 900);
    }
  } else if (!dismissed && !subscribed) {
    const delay = Number(popup.dataset.delay || 0);
    window.setTimeout(openPopup, delay);
  }

  const copyButton = popup.querySelector('[data-copy-discount]');
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = popup.querySelector('[data-discount-code]')?.textContent?.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = 'Copied!';
      } catch (e) {
        copyButton.textContent = code;
      }
    });
  }
});


window.addEventListener('DOMContentLoaded', () => {
  const shuffle = (items) => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };

  document.querySelectorAll('[data-rotate-products]').forEach((grid) => {
    const items = [...grid.querySelectorAll(':scope > .rotating-product-item')];
    const visibleCount = Math.max(1, Number(grid.dataset.visibleCount || 4));
    const seconds = Math.max(8, Number(grid.dataset.rotateSeconds || 20));
    if (!items.length) return;

    let previous = new Set();

    const showNext = () => {
      let pool = shuffle(items);
      // Prefer a completely different set from the last round when enough products exist.
      if (items.length >= visibleCount * 2 && previous.size) {
        const fresh = pool.filter((item) => !previous.has(item));
        const repeats = pool.filter((item) => previous.has(item));
        pool = [...fresh, ...repeats];
      }
      const next = pool.slice(0, Math.min(visibleCount, items.length));
      const nextSet = new Set(next);

      items.forEach((item) => item.classList.toggle('is-rotation-visible', nextSet.has(item)));
      previous = nextSet;
    };

    showNext();
    if (items.length > visibleCount) {
      window.setInterval(showNext, seconds * 1000);
    }
  });
});
